import {Icon, IconProps} from '@chakra-ui/react';

export const SendIcon: React.FC<IconProps> = (props) => (
  <Icon
    viewBox='0 0 16 14'
    {...props}
  >
    <path
      d='M0 13.3333V0L15.8333 6.66667L0 13.3333ZM1.66667 10.8333L11.5417 6.66667L1.66667 2.5V5.41667L6.66667 6.66667L1.66667 7.91667V10.8333Z'
      fill='currentColor'
    />
  </Icon>
);
